export const ActionTypes = {
  LOADING: "DELETE_PROS_LOADING",
  ERROR: "DELETE_PROS_ERROR",
  SUCCESS: "DELETE_PROS_SUCCESS",
};
